/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as CreateImport } from './routes/create'
import { Route as IndexImport } from './routes/index'
import { Route as IncentiveEnergizeImport } from './routes/incentive/energize'
import { Route as IncentiveObjectIdImport } from './routes/incentive/$objectId'

// Create/Update Routes

const CreateRoute = CreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const IncentiveEnergizeRoute = IncentiveEnergizeImport.update({
  id: '/incentive/energize',
  path: '/incentive/energize',
  getParentRoute: () => rootRoute,
} as any)

const IncentiveObjectIdRoute = IncentiveObjectIdImport.update({
  id: '/incentive/$objectId',
  path: '/incentive/$objectId',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/create': {
      id: '/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateImport
      parentRoute: typeof rootRoute
    }
    '/incentive/$objectId': {
      id: '/incentive/$objectId'
      path: '/incentive/$objectId'
      fullPath: '/incentive/$objectId'
      preLoaderRoute: typeof IncentiveObjectIdImport
      parentRoute: typeof rootRoute
    }
    '/incentive/energize': {
      id: '/incentive/energize'
      path: '/incentive/energize'
      fullPath: '/incentive/energize'
      preLoaderRoute: typeof IncentiveEnergizeImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/create': typeof CreateRoute
  '/incentive/$objectId': typeof IncentiveObjectIdRoute
  '/incentive/energize': typeof IncentiveEnergizeRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/create': typeof CreateRoute
  '/incentive/$objectId': typeof IncentiveObjectIdRoute
  '/incentive/energize': typeof IncentiveEnergizeRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/create': typeof CreateRoute
  '/incentive/$objectId': typeof IncentiveObjectIdRoute
  '/incentive/energize': typeof IncentiveEnergizeRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/create' | '/incentive/$objectId' | '/incentive/energize'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/create' | '/incentive/$objectId' | '/incentive/energize'
  id:
    | '__root__'
    | '/'
    | '/create'
    | '/incentive/$objectId'
    | '/incentive/energize'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CreateRoute: typeof CreateRoute
  IncentiveObjectIdRoute: typeof IncentiveObjectIdRoute
  IncentiveEnergizeRoute: typeof IncentiveEnergizeRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CreateRoute: CreateRoute,
  IncentiveObjectIdRoute: IncentiveObjectIdRoute,
  IncentiveEnergizeRoute: IncentiveEnergizeRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/create",
        "/incentive/$objectId",
        "/incentive/energize"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/create": {
      "filePath": "create.tsx"
    },
    "/incentive/$objectId": {
      "filePath": "incentive/$objectId.tsx"
    },
    "/incentive/energize": {
      "filePath": "incentive/energize.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
